<template>
  <div style="width: 99.8%;">
    <div style="margin-bottom: 5px;">
      <el-button size="mini" @click="postAdd">保存</el-button>
      <el-button size="mini" @click="setComponentId('VirtuallyMain')">返回</el-button>
    </div>
    <div class="cdj_div">仪表编号（{{setup_list.number}}）收费标准设置</div>
    <div class="cdj_table">
      <div class="cdj_display">
        <div class="cdj_left">
          <div class="cdj_left_display">
            <div class="cdj_left_display_background">仪表名称</div>
            <div class="cdj_el-input">
              <el-input  placeholder="" v-model="setup_list.dummy_meter_name" clearable disabled></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">仪表所在房产</div>
            <div class="cdj_el-input">
              <el-input  placeholder="" v-model="setup_list.HouseName" clearable disabled></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">附件</div>
            <div class="cdj_el-input">

            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">空置房收费对象</div>
            <div class="cdj_el-input" style="display: flex;">
              <el-input  placeholder="" v-model="developer.name" clearable></el-input>
              <el-button style="margin-left: 3px;" @click="updatesc">选择</el-button>
            </div>
          </div>
        </div>
        <div class="cdj_left">
          <div class="cdj_left_display">
            <div class="cdj_left_display_background">收费标准</div>
            <div class="cdj_el-input">
              <el-input  placeholder="" v-model="setup_list.cname" clearable disabled></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">费用单价</div>
            <div class="cdj_el-input el-date-pickers">
              <el-input placeholder="" v-model="setup_list.charge" clearable disabled></el-input>
            </div>
          </div>
          <div class="cdj_left_display cdj_top">
            <div class="cdj_left_display_background">默认收费对象</div>
            <div class="cdj_el-input el-date-pickers" style="margin-top: 7px;">
              <el-radio v-model="name_type" label="1">业主</el-radio>
              <el-radio style="margin-left: -10px;" v-model="name_type" label="2">租户</el-radio>
              <span style="margin-left: 5px;color:red;">(指从左侧选择房产时，默认的收费对象类型)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分摊组件 -->
    <el-tabs v-model="activeName" @tab-click="handleClick"  style="margin-top: 1px;">
      <el-tab-pane label="通用分摊" name="currency">
        <VirtuallyCurrency ref="VirtuallyCurrencyRef" :house="house" :activeName="activeName" :setup_list="setup_list"></VirtuallyCurrency>
      </el-tab-pane>
      <el-tab-pane label="平均分摊" name="average">
        <VirtuallyAverage ref="VirtuallyAverageRef" :house="house" :activeName="activeName" :setup_list="setup_list"></VirtuallyAverage>
      </el-tab-pane>
      <el-tab-pane ref="child" label="面积分摊" name="area">
        <VirtuallyArea ref="VirtuallyAreaRef" :house="house" :activeName="activeName" :setup_list="setup_list"></VirtuallyArea>
      </el-tab-pane>
      <el-tab-pane label="用量分摊" name="consumption">
        <VirtuallyConsumption ref="VirtuallyConsumptionRef" :house="house" :activeName="activeName" :setup_list="setup_list"></VirtuallyConsumption>
      </el-tab-pane>
      <el-tab-pane label="楼层分摊" name="floor">
        <VirtuallyFloor ref="VirtuallyFloorRef" :house="house" :activeName="activeName" :setup_list="setup_list"></VirtuallyFloor>
      </el-tab-pane>
    </el-tabs>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "VirtuallyCustomer",
  inject:['mainObj','componentId','setComponentId'],
  components: {
    // "erp-tree": () => import('../../../Common/erp-tree.vue'),
    "room-user": () => import('../../../Common/room-user.vue'),
    VirtuallyCurrency: () => import('./components/VirtuallyCurrency.vue'),
    VirtuallyAverage: () => import('./components/VirtuallyAverage.vue'),
    VirtuallyArea: () => import('./components/VirtuallyArea.vue'),
    VirtuallyConsumption: () => import('./components/VirtuallyConsumption.vue'),
    VirtuallyFloor: () => import('./components/VirtuallyFloor.vue')
  },
  data(){
    return{
      house:'',
      activeName:'currency',
      setup_list:{},
      developer:[],
      name_type:"1",
      modal1:false
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      const that=this;
      ERP.getRequest({
        url:"admin/MeterVirtually/getShareSetup",
        data:{id:that.mainObj.id,}
      },ret=>{
        if(ret.code){
          that.setup_list = ret.data;
          that.getDataUser();
        }
      })
    },
    //点击设置
    getDataUser(){
      //console.log(item)
      const that=this;
      ERP.getRequest({
        url:"admin/ShareSetup/shareId",
        data:{
          id:that.mainObj.id,
        }
      },ret=>{
        if(ret.code == 200){
          if(ret.type == 1){
            that.$refs.VirtuallyCurrencyRef.datas(ret.data)
          }
          if(ret.type == 2){
            that.$refs.VirtuallyAverageRef.datas(ret.data)
          }
          if(ret.type == 3){
            that.$refs.VirtuallyAreaRef.datas(ret.data)
          }
          if(ret.type == 4){
            that.$refs.VirtuallyConsumptionRef.datas(ret.data)
          }
          if(ret.type == 5){
            that.$refs.VirtuallyFloorRef.datas(ret.data)
          }
        }
      });
      // that.setup_list = item;
      that.setup_list.name_type = this.name_type;
      that.seup = 2;
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      // this.change(1);
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.house = tree_str;
      if(this.seup == 1){
        this.change(1);
      }else{
        this.setup_list.name_type = this.name_type;
        this.son_user(tree_str);
      }
    },
    //切换组件
    handleClick(){
      //console.log(this.activeName)
    },
    postAdd(){
      const that=this;
      let data = [];
      if(that.activeName == 'currency'){
        data = that.$refs.VirtuallyCurrencyRef.getUser()
      }
      if(that.activeName == 'average'){
        data = that.$refs.VirtuallyAverageRef.getUser()
      }
      if(that.activeName == 'area'){
        data = that.$refs.VirtuallyAreaRef.getUser()
      }
      if(that.activeName == 'consumption'){
        data = that.$refs.VirtuallyConsumptionRef.getUser()
      }
      if(that.activeName == 'floor'){
        data = that.$refs.VirtuallyFloorRef.getUser()
      }
      let post = {type:that.activeName,data:data,setup_list:that.setup_list}
      ERP.getRequest({
        url:"admin/ShareSetup/post",
        data:post
      },ret=>{
        if(ret.code == 200){
          this.seup = 1;
          this.change(1);
          this.$Message.success('操作成功!');
        }else{
          this.$Message.error(ret.message);
        }
      });
    },
    //选择客户
    roomUser(){
      this.developer = this.$refs.child.getUser();
    },
    //选择客户
    updatesc(){
      this.modal1 = true;
    },
  }
}
</script>

<style lang="scss" scoped>
.cdj_div{
  padding: 7px;
  background-color: #ececec;
}
.cdj_table{
  width: 100%;
  border-left: 1px solid #ececec;
  border-right: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  padding: 5px;
}
.cdj_display{
  display: flex;
}
.cdj_left{
  width: 50%;
  color: #000;
}
.cdj_left_display{
  display: flex;
}
.cdj_left_display_background{
  width: 130px;
  padding: 5px;
  background-color: #ececec;
}
.cdj_el-input{
  width: 60%;
  margin-left: 5px;
}
.el-date-pickers{
  display: flex;
}
.cdj_text_data{
  margin-left: 3px;
  margin-right: 3px;
  margin-top: 4px;
}
.cdj_top{
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/VirtuallyCustomer.vue